const routes = [
  {
    path: '/user',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      { path: 'dashboard', component: () => import('pages/IndexPage.vue') },
      { path: 'usage', component: () => import('pages/ServiceUsage.vue') },
      // { path: 'uploadcel', component: () => import('pages/ga/UploadCel.vue') },
      { path: 'profile', component: () => import('pages/user/Profile.vue') },
      { path: 'qna', component: () => import('pages/user/QnA.vue') },
      { path: 'org_info/:org_code', component: () => import('pages/user/OrgInfo.vue') },
    ],
  },
  {
    path: '/service',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      { path: 'dashboard', component: () => import('pages/IndexPage.vue') },
      { path: 'status/:service_code/:subscription_id', component: () => import('pages/ServiceStatus.vue') },
      // { path: 'upload_cel/:subscription_id', component: () => import('pages/ga/UploadCel.vue') },
      { path: 'usage', component: () => import('pages/ServiceUsage.vue') },
      { path: 'usage/:service_code', component: () => import('pages/ServiceUsage.vue') },
      { path: 'usagedetail/:service_code', component: () => import('pages/ServiceUsageDetail.vue') },
      { path: 'api_guide/:subscription_id', component: () => import('pages/ServiceAPIGuide.vue') },
      { path: 'add_task/:subscription_id', component: () => import('pages/ga/AddTask.vue') },
      { path: 'add_task/:subscription_id/:task_id', component: () => import('pages/ga/AddTask.vue') },
      { path: 'task_detail/:task_id', component: () => import('pages/ServiceTaskDetail.vue') },
      { path: 'tasklist/:status/:subscription_id', component: () => import('pages/ServiceTaskList.vue') },
      { path: 'taskdonelist/:subscription_id', component: () => import('pages/ServiceTaskDoneList.vue') },

      //////////////// ffq_dangpro ////////////////////////
      { path: 'status/ffq_dangpro/:subscription_id', component: () => import('pages/service_specific/ffq_dangpro/ServiceStatus.vue') },
      { path: 'taskdonelist/ffq_dangpro/:subscription_id', component: () => import('pages/service_specific/ffq_dangpro/ServiceTaskDoneList.vue') },
      //////////////// dangreport_dangpro ////////////////////////
      { path: 'status/dangreport_dangpro/:subscription_id', component: () => import('pages/service_specific/dangreport_dangpro/ServiceStatus.vue') },
      { path: 'taskdonelist/dangreport_dangpro/:subscription_id', component: () => import('pages/service_specific/dangreport_dangpro/ServiceTaskDoneList.vue') },
      //////////////// dangreport_miriwell ////////////////////////
      { path: 'status/dangreport_miriwell/:subscription_id', component: () => import('pages/service_specific/dangreport_miriwell/ServiceStatus.vue') },
      { path: 'taskdonelist/dangreport_miriwell/:subscription_id', component: () => import('pages/service_specific/dangreport_miriwell/ServiceTaskDoneList.vue') },
      //////////////// healthreport_salus ////////////////////////
      { path: 'status/healthreport_salus/:subscription_id', component: () => import('pages/service_specific/healthreport_salus/ServiceStatus.vue') },
      { path: 'taskdonelist/healthreport_salus/:subscription_id', component: () => import('pages/service_specific/healthreport_salus/ServiceTaskDoneList.vue') },
      //////////////// wg-gas ////////////////////////
      { path: 'status/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/ServiceStatus.vue') },
      { path: 'add_task/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/AddSampleInfo.vue') },
      { path: 'pack_request/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/PackRequest.vue') },
      { path: 'add_kitnum/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/AddKitnum.vue') },
      { path: 'upload_rawdata/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/UploadRawData.vue') },
      { path: 'add_traitreport/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/AddTraitReport.vue') },
      { path: 'add_genecheck/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/AddGeneCheck.vue') },
      { path: 'print_request/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/PrintRequest.vue') },
      { path: 'tasklist/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/ServiceTaskList.vue') },
      { path: 'taskdonelist/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/ServiceTaskDoneList.vue') },
      { path: 'taskdeletelist/wg-gas/:subscription_id', component: () => import('pages/service_specific/wg-gas/ServiceTaskDeleteList.vue') },
      { path: 'task_detail/wg-gas/:task_id/:subscription_id', component: () => import('pages/service_specific/wg-gas/ServiceTaskDetail.vue') },
    ],
  },
  {
    path: '/admin',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: '', component: () => import('pages/IndexPage.vue') },
      // Server
      { path: 'server_list', component: () => import('pages/admin/ServerList.vue') },
      { path: 'server_add', component: () => import('pages/admin/ServerAdd.vue') },
      { path: 'server_add/:server_id', component: () => import('pages/admin/ServerAdd.vue') },
      { path: 'server_detail/:server_id', component: () => import('pages/admin/ServerDetail.vue') },
      // User
      { path: 'user_list', component: () => import('pages/admin/UserList.vue') },
      { path: 'user_add', component: () => import('pages/admin/UserAdd.vue') },
      { path: 'user_detail/:user_id', component: () => import('pages/admin/UserDetail.vue') },
      // Org

      { path: 'org_detail/service_usage/:org_code/:service_code', component: () => import('pages/ServiceUsage.vue') },
      { path: 'subscription_detail/:subscription_id', component: () => import('pages/admin/SubscriptionDetail.vue') },
      // Subscription
      { path: 'subscription_list', component: () => import('pages/admin/SubscriptionList.vue') },
      // Service
      { path: 'service_list', component: () => import('pages/admin/ServiceList.vue') },
      { path: 'service_add', component: () => import('pages/admin/ServiceAdd.vue') },
      { path: 'service_add/:service_code', component: () => import('pages/admin/ServiceAdd.vue') },
      { path: 'service_del/:service_code', component: () => import('pages/admin/ServiceDel.vue') },
      { path: 'service_detail/:service_code', component: () => import('pages/admin/ServiceDetail.vue') },
      // Task
      { path: 'taskdone_list', component: () => import('pages/admin/TaskDoneList.vue') },
      { path: 'task_list', component: () => import('pages/admin/TaskList.vue') },
      { path: 'task_detail/:task_id', component: () => import('pages/admin/TaskDetail.vue') },
      // qna
      { path: 'qna_list', component: () => import('pages/admin/QnAList.vue') },
    ],
  },
  {
    // 기관관리
    path: '/admin/org',
    component: () => import('layouts/MainLayout.vue'),
    children: [
      { path: 'list', component: () => import('pages/admin/OrgList.vue') },
      { path: 'detail/:org_code', component: () => import('pages/admin/OrgDetail.vue') },
      { path: 'add', component: () => import('pages/admin/OrgAdd.vue') },
      { path: 'mod/:org_code', component: () => import('pages/admin/OrgMod.vue') },
    ],
  },
  {
    path: '/',
    component: () => import('layouts/BlankLayout.vue'),
    children: [
      { path: '', component: () => import('pages/SignIn.vue') },
      { path: 'signin', component: () => import('pages/SignIn.vue') },
      { path: 'signup', component: () => import('pages/SignUp.vue') },
    ],
  },

  // Always leave this as last one,
  // but you can also remove it
  {
    path: '/:catchAll(.*)*',
    component: () => import('pages/ErrorNotFound.vue'),
  },
];

export default routes;
